module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_111_8.2318a4f7.pdf";